
import debounce from "lodash/debounce"
import { mapActions } from "vuex"
import accountMixin from "@/mixins/account"

export default {
  mixins: [accountMixin],

  async middleware ({ route, redirect, app, $api }) {
    const userId = route.query.user || ""
    if (!userId) return

    const goToChat = (chatId = "") =>
      redirect(app.localePath(`/account/chat/${chatId || ""}`))

    const [res, err] = await $api.chat.createPrivateChat(userId)
    if (err) return goToChat()
    return goToChat(res?.id)
  },

  head () {
    return { title: this.$t("account.tabs.chats") }
  },

  computed: {
    visible: {
      get () { return this.user.visible },
      set: debounce(async function (visible) {
        const [, err] = await this.updateUser({ visible })
        if (err) console.error(err)
      }, 500),
    },
  },

  methods: {
    ...mapActions("user", ["updateUser"]),
  },
}
